<template>
<div class="chapter">
<div class="inner_page">
<p class="fut_toc"> </p>
<p class="fut_toc1"><a href="#/xhtml/dedication#ded">Begin Reading</a></p>
<p class="fut_toc1"><span href="#/xhtml/contents" title="Link target outside of Sample">Table of Contents</span></p>
<p class="fut_toc1"><span href="#/xhtml/abouttheauthor#about" title="Link target outside of Sample">About the Author</span></p>
<p class="fut_toc1"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright Page</span></p>
<p class="fut_toc1"> </p>
<p class="fut_toc"><span class="ePub-B">Thank you for buying this</span></p>
<p class="fut_toc"><span class="ePub-B">Flatiron Books ebook.</span></p>
<p class="fut_toc"> </p>
<p class="fut_toc">To receive special offers, bonus content,</p>
<p class="fut_toc">and info on new releases and other great reads,</p>
<p class="fut_toc">sign up for our newsletters.</p>
<p class="fut_toc"> </p>
<p class="fut_tit" id="newsa"><a href="http://us.macmillan.com/newslettersignup?utm_source=ebook&amp;utm_medium=adcard&amp;utm_term=ebookreaders&amp;utm_content=mrlloydhandwerker_newslettersignup_macdotcom&amp;utm_campaign=9781250074560" target="_blank"><img alt="image" height="67" src="images/NewsletterSignup.jpg" width="112"/></a></p>
<p class="fut_toc">Or visit us online at</p>
<p class="fut_toc"><a href="http://us.macmillan.com/newslettersignup?utm_source=ebook&amp;utm_medium=adcard&amp;utm_term=ebookreaders&amp;utm_content=mrlloydhandwerker_newslettersignup_macdotcom&amp;utm_campaign=9781250074560" target="_blank">us.macmillan.com/newslettersignup</a></p>
<p class="fut_toc"> </p>
<p class="fut_toc">For email updates on Lloyd Handwerker, click <a href="http://us.macmillan.com/authoralerts?authorName=mrlloydhandwerker&amp;authorRefId=119394622&amp;utm_source=ebook&amp;utm_medium=adcard&amp;utm_term=ebookreaders&amp;utm_content=mrlloydhandwerker_authoralertsignup_macdotcom&amp;utm_campaign=9781250074560" target="_blank">here</a>.</p>
<p class="fut_toc">For email updates on Gil Reavill, click <a href="http://us.macmillan.com/authoralerts?authorName=gilreavill&amp;authorRefId=33694791&amp;utm_source=ebook&amp;utm_medium=adcard&amp;utm_term=ebookreaders&amp;utm_content=gilreavill_authoralertsignup_macdotcom&amp;utm_campaign=9781250074560" target="_blank">here</a>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mini_toc.vue?0797de78